module.exports = __webpack_public_path__ + "static/media/22_A.0b0f8d36.png";